import { useState } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { Page, PageFace, Toggle } from 'ui/components'

import { ContactsChanges } from './ContactsChanges'
import { Footer } from './Footer'
import { LicensesChanges } from './LicensesChanges'
import { RelationshipChanges } from './RelationshipChanges'
import { ApplicationChangesDetailsWebPage } from './types'

import * as SC from './styles'

const routeApi = getRouteApi('/_app/onboarding/applications/$applicationId/warnings-details')

const ApplicationChangesDetails = () => {
  const [showAll, setShowAll] = useState(true)

  // @todo why type not working, look at this when we get worked router types
  const { webPage, applicationId }: { webPage: ApplicationChangesDetailsWebPage; applicationId: number } =
    routeApi.useLoaderData()

  return (
    <Page
      face={PageFace.SECONDARY}
      subTitle="Application Changes Details"
      footerV2={<Footer applicationId={applicationId} data={webPage} />}
    >
      <SC.TitleWrapper>
        <SC.Title>Please review these changes carefully before proceeding.</SC.Title>
        <SC.Actions>
          <Toggle value={showAll} label="Show all" onChange={() => setShowAll(!showAll)} />
        </SC.Actions>
      </SC.TitleWrapper>

      <SC.Panels>
        {webPage.showRelationshipChanges !== undefined && (
          <RelationshipChanges showAll={showAll} data={webPage.showRelationshipChanges} />
        )}

        {webPage.showLicensesChanges && <LicensesChanges showAll={showAll} data={webPage.showLicensesChanges} />}

        {webPage.showContactsChanges && <ContactsChanges showAll={showAll} data={webPage.showContactsChanges} />}
      </SC.Panels>
    </Page>
  )
}

export default ApplicationChangesDetails
